import React from 'react';
import { StyleSheet } from 'react-native';

import { InnerBorder } from '@/components/InnerBorder';
import { Text, TextProps } from '@/components/TextComponent';
import { Box, BoxProps } from '@/components/lib/components';
import { ds } from '@/components/lib/design.system';

export const PromoTag = ({ children, style, ...boxProps }: BoxProps) => (
    <Box
        alignSelf="flex-start"
        borderRadius="r9"
        padding="s8"
        flexDirection="row"
        alignItems="center"
        gap="s8"
        overflow="hidden"
        style={[styles.maxFull, style]}
        {...boxProps}
    >
        <InnerBorder borderRadius="r9" borderColor={ds.colorValue.border.subtle} />
        {children}
    </Box>
);

export const PromoTagLabel = (props: TextProps) => (
    <Text variant="labelLarge2" lineHeight={16} letterSpacing={-0.08} {...props} />
);

const styles = StyleSheet.create({
    maxFull: { maxWidth: '100%' },
});
